import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDownload, Footer } from "../../components";
import { getAllBrands } from "../../redux/actions/brandActions";
import { AiOutlineSearch } from "react-icons/ai";
import { fetchBrandProducts } from "../../redux/actions/productActions";
import ShopProduct from "./ShopProduct";
import { Helmet } from "react-helmet";
import { Link,useParams } from "react-router-dom";
import { BsFillGridFill } from "react-icons/bs";
import { FaList } from "react-icons/fa";
const BrandShop = () => {
  const dispatch = useDispatch();
  const [gridView, setGridView] = useState(true);
  const { brands } = useSelector((state) => state.allBrands);

  const { brandName } = useParams();
  const [brand, setBrand] = useState("");
  const [sort, setSort] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const token = useSelector((state) => state.userLogin?.userInfo?.access_token);
  const sx = useSelector((state) => state.userLogin?.userInfo?.user);

  useEffect(() => {
    if (brandName) {
      setBrand(brandName);
    }else{}
    console.log("brabndname", brandName);
  }, [brandName]);
  useEffect(() => {
    if (brandName) {
        setBrand(brandName);
        console.log("fetch brand product called", brandName);
     dispatch(fetchBrandProducts(page, brandName, sort, search,token, sx.sn));
      }else{
    dispatch(fetchBrandProducts(page, brand, sort, search,token, sx.sn));
      }
  }, [dispatch, page, brand, sort, search,token, sx.sn]);

  const handleBrand = (e) => {
    setBrand(e.target.value);
    setSearch("");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch(getAllBrands(token));
  }, [dispatch,token]);



  return (
    <section className="shop-main">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Brand</title>
      </Helmet>
      {/* <div className="title">
        <div>
          <h2>All Products</h2>

          <div className="breadcramp">
            <Link to="/">Home</Link>
            <span className="arrow">{">"}</span>
            <span className="active-page">Shop</span>
          </div>
        </div>
      </div> */}
      <div className="shop container-div">
        <div className="shop__filter grid">
          <div className="shop__filter__search">
            <AiOutlineSearch />
            <input
              type="text"
              value={search}
              placeholder="Enter your search!"
              onChange={(e) => setSearch(e.target.value.toLowerCase())}
            />
          </div>
          {/* <div className="shop__filter__brand">
            <p>Filters: </p>
            <select name="brand" value={brand} onChange={handleBrand}>
              <option value="">All Products</option>
              {brands?.map((brand) => (
                <option
                  style={{ textTransform: "capitalize" }}
                  value={"brand=" + brand.name}
                  key={brand._id}
                >
                  {brand.name}
                </option>
              ))}
            </select>
          </div>

          <div className="shop__filter__brand">
            <p>Sort by: </p>

            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="">Newest</option>
              <option value="sort=oldest">Oldest</option>
              <option value="sort=-sold">Best sales</option>
              <option value="sort=-price">Price: High-Low</option>
              <option value="sort=price">Price: Low-High</option>
            </select>
          </div> */}

          <div className="grid-view-container">
            <div
              onClick={() => setGridView(true)}
              className={`${gridView ? "grid-active" : "grid-icon"}`}
            >
              <BsFillGridFill />
            </div>
            <div
              onClick={() => setGridView(false)}
              className={`${!gridView ? "grid-active" : "grid-icon"}`}
            >
              <FaList />
            </div>
          </div>
        </div>

        <ShopProduct gridView={gridView} page={page} setPage={setPage} />
      </div>
      {/* <AppDownload /> */}
      <Footer />
    </section>
  );
};

export default BrandShop;
